import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import FloatingCTAs from './components/FloatingCTAs'

// Pages
import Home from './pages/Home'
import ServiceDetail from './pages/ServiceDetail'
import Projects from './pages/Projects'
import About from './pages/About'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-800 antialiased">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Header / Navigation */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/projekter" element={<Projects />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating CTA Buttons */}
      <FloatingCTAs />
    </div>
  )
}
